<template>
  <div id="tosf-hei-profile-dashboard">
    <div class="row mt-1 my-0 px-0">
      <div class="col">
        <div class="row">
          <div class="col">
            <div class="">
              <div class="">
                <div class="form-row">
                  <div class="col-4 text-center my-auto">
                    <div class="my-auto">
                      <i class="bi bi-building display-1 text-primary"></i>
                    </div>

                    <p class="mt-3">
                      Status:
                      <span 
                        class="font-weight-bold"
                        :class="{
                          'text-success': heiProfile.hei_status === 'Active',
                          'text-warning': heiProfile.hei_status === 'Inactive',
                          'text-danger': heiProfile.hei_status === 'Suspended'
                        }"
                      >
                        {{ heiProfile.hei_status }}
                      </span>
                    </p>
                  </div>
                  <div class="col-8">
                    <div class="text-center">
                      <p class="lead font-weight-bold mb-0">
                        {{ heiProfile.hei_name }} ({{ heiProfile.hei_code }})
                      </p>
                      <span class="text-muted">{{ heiProfile.hei_address }}</span>
                      <hr class="my-2" />
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <label class="font-weight-bold my-0">HEI Code</label>
                        <p>{{ heiProfile.hei_code }}</p>
                      </div>

                      <div class="col-md-6">
                        <label class="font-weight-bold my-0">Academic Year</label>
                        <p>{{ heiProfile.academic_year }}</p>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <label class="font-weight-bold my-0">Reference Number</label>
                        <p>{{ heiProfile.reference_number || 'N/A' }}</p>
                      </div>

                      <div class="col-md-6">
                        <label class="font-weight-bold my-0">Status</label>
                        <p>
                          <span 
                            class="badge"
                            :class="{
                              'badge-success': heiProfile.hei_status === 'Active',
                              'badge-warning': heiProfile.hei_status === 'Inactive',
                              'badge-danger': heiProfile.hei_status === 'Suspended'
                            }"
                          >
                            {{ heiProfile.hei_status }}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <label class="font-weight-bold my-0">Created At</label>
                        <p>{{ heiProfile.created_at | standardDate }}</p>
                      </div>

                      <div class="col-md-6">
                        <label class="font-weight-bold my-0">Updated At</label>
                        <p>{{ heiProfile.updated_at | standardDate }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Programs Summary -->
        <div class="row mt-4">
          <div class="col">
            <div class="card">
              <div class="card-header bg-info text-white">
                <h6 class="mb-0">
                  <i class="bi bi-graduation-cap mr-2"></i>Programs Summary
                </h6>
              </div>
              <div class="card-body">
                <div v-if="heiProfile.programs_data && heiProfile.programs_data.length > 0">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="text-center">
                        <h4 class="text-primary">{{ heiProfile.programs_data.length }}</h4>
                        <p class="text-muted mb-0">Total Programs</p>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="text-center">
                        <h4 class="text-success">₱{{ calculateAverageFees().toLocaleString() }}</h4>
                        <p class="text-muted mb-0">Average Total Fees</p>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="text-center">
                        <h4 class="text-warning">₱{{ calculateTotalFees().toLocaleString() }}</h4>
                        <p class="text-muted mb-0">Grand Total Fees</p>
                      </div>
                    </div>
                  </div>
                  
                  <div class="mt-3">
                    <h6>Program List:</h6>
                    <div class="row">
                      <div 
                        v-for="(program, index) in heiProfile.programs_data" 
                        :key="index"
                        class="col-md-6 mb-2"
                      >
                        <div class="card border-left-primary">
                          <div class="card-body py-2">
                            <h6 class="mb-1">{{ program.degree_program || `Program ${index + 1}` }}</h6>
                            <small class="text-muted">
                              Total: ₱{{ calculateProgramTotal(program).toLocaleString() }}
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="text-center text-muted">
                  <i class="bi bi-inbox display-4"></i>
                  <p class="mt-2">No programs available</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TosfHeiProfile_Dashboard',
  props: ['heiProfile'],
  methods: {
    calculateProgramTotal(program) {
      if (!program.years) return 0;
      
      let total = 0;
      program.years.forEach(year => {
        const firstSemTotal = parseFloat((year.first_sem && year.first_sem.total_fees) || 0);
        const secondSemTotal = parseFloat((year.second_sem && year.second_sem.total_fees) || 0);
        total += firstSemTotal + secondSemTotal;
      });
      
      return total;
    },

    calculateTotalFees() {
      if (!this.heiProfile.programs_data) return 0;
      
      let grandTotal = 0;
      this.heiProfile.programs_data.forEach(program => {
        grandTotal += this.calculateProgramTotal(program);
      });
      
      return grandTotal;
    },

    calculateAverageFees() {
      if (!this.heiProfile.programs_data || this.heiProfile.programs_data.length === 0) return 0;
      
      const totalFees = this.calculateTotalFees();
      return Math.round(totalFees / this.heiProfile.programs_data.length);
    }
  }
};
</script>

<style scoped>
.border-left-primary {
  border-left: 4px solid #007bff !important;
}

.card-body.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
</style>
